import PropTypes from "prop-types";
import { ContentModal } from "../Layout/templates";

const ResourceModal = ({ resourceId, isOpen, onClose }) => {
  const renderResource = (resourceId) => {
    switch (resourceId) {
      case "antibiotic-summary":
        return (
          <iframe
            src={`https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/PDFs/Antibiotic-Summary-table.pdf`}
            width="100%"
            height="500px"
            title="Antibiotic Summary Table"
          />
        );
      case "surgical-prophylaxis":
        return (
          <iframe
            src={`https://ccmsfiles.tg.org.au/${import.meta.env.REACT_APP_CCMS_VERSION}/PDFs/ABG17-SAP-summary-tables-collated.pdf`}
            width="100%"
            height="500px"
            title="Surgical Prophylaxis Tables"
          />
        );
      case "patient-info":
        // This would need to be implemented based on your patient info component
        return <div>Patient Information Component - To be implemented</div>;
      case "pregnancy-breastfeeding":
        // This would need to be implemented based on your pregnancy/breastfeeding component
        return <div>Pregnancy and Breastfeeding Component - To be implemented</div>;
      case "tables-figures":
        // This would need to be implemented based on your tables and figures component
        return <div>Tables and Figures Component - To be implemented</div>;
      default:
        return <div>Resource not found</div>;
    }
  };

  const getResourceTitle = (resourceId) => {
    const resourceTitles = {
      "antibiotic-summary": "Antibiotic prescribing in primary care - summary table",
      "surgical-prophylaxis": "Surgical prophylaxis - summary tables",
      "patient-info": "Patient information and useful PDFs",
      "pregnancy-breastfeeding": "Pregnancy and breastfeeding",
      "tables-figures": "Tables and figures",
    };
    return resourceTitles[resourceId] || "Resource";
  };

  return (
    <ContentModal
      contentId={resourceId}
      isOpen={isOpen}
      onClose={onClose}
      getContentTitle={getResourceTitle}
      renderContent={renderResource}
    />
  );
};

ResourceModal.propTypes = {
  resourceId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ResourceModal;
